import { create } from 'zustand';

interface OfferState {
    encryptedToken: string | null;
    displayData: any | null;
    successData: any | null;

    setOfferData: (token: string, safeData: any) => void;
    clearOfferData: () => void;
    setSuccessData: (data: any) => void;
    clearSuccessData: () => void;
}

export const useOfferStore = create<OfferState>((set) => ({
    encryptedToken: null,
    displayData: null,
    successData: null,

    setOfferData: (token, safeData) => set({ encryptedToken: token, displayData: safeData }),
    clearOfferData: () => set({ encryptedToken: null, displayData: null }),
    setSuccessData: (data) => set({ successData: data }),
    clearSuccessData: () => set({ successData: null })
}));